'use client';

import { c as _c } from "react/compiler-runtime";
import { TERMOS_SECOES } from '../constants';
import { SimpleLogoHeader } from './SimpleLogoHeader';
interface TermsScreenProps {
  onVoltar: () => void;
}
export const TermsScreen = t0 => {
  const $ = _c(6);
  const {
    onVoltar
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SimpleLogoHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="top-6 flex flex-col gap-1 md:sticky md:h-fit md:basis-[220px]"><span className="mb-2 text-[11px] font-bold tracking-wider text-neutral-500 uppercase">Navegação</span>{TERMOS_SECOES.map(_temp)}</div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mx-auto flex w-full max-w-[1200px] flex-1 flex-col gap-10 px-6 py-10 md:flex-row md:gap-16 md:px-20 md:py-12">{t2}<div className="flex max-w-[680px] flex-1 flex-col gap-8"><div><h1 className="text-heading-dark mb-2 text-xl font-semibold sm:text-[26px]">Termos de Uso e Política de Privacidade</h1><span className="text-[13px] text-neutral-500">Última atualização: Janeiro de 2025</span><p className="mt-4 text-[15px] leading-relaxed text-neutral-700">Estes Termos de Uso e Política de Privacidade regem o uso da plataforma Lexi, uma ferramenta de automação e inteligência artificial para negociações. Ao utilizar nossos serviços, você concorda com as condições abaixo.</p></div>{TERMOS_SECOES.map(_temp2)}</div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-xs text-neutral-500">© 2025 Lexi. Todos os direitos reservados.</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onVoltar) {
    t5 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t3}<div className="flex items-center justify-between border-t border-solid border-neutral-200 px-6 py-5 md:px-20">{t4}<button type="button" onClick={onVoltar} className="text-brand-600 text-[13px] font-semibold">Voltar</button></div></div>;
    $[4] = onVoltar;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
function _temp(secao) {
  return <span key={secao.titulo} className="text-label-muted py-1.5 text-[13px]">{secao.titulo}</span>;
}
function _temp2(secao_0) {
  return <div key={secao_0.titulo} className="flex flex-col gap-3 border-t border-solid border-neutral-200 pt-6"><span className="text-heading-dark text-xl font-bold">{secao_0.titulo}</span><span className="text-[15px] leading-relaxed text-neutral-700">{secao_0.corpo}</span></div>;
}